import { render, staticRenderFns } from "./channelMaterialSet.vue?vue&type=template&id=7af9bbaa&scoped=true&"
import script from "./channelMaterialSet.vue?vue&type=script&lang=js&"
export * from "./channelMaterialSet.vue?vue&type=script&lang=js&"
import style0 from "./channelMaterialSet.vue?vue&type=style&index=0&id=7af9bbaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af9bbaa",
  null
  
)

export default component.exports